import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const recordPhone = async (
  cartTag: string,
  phone: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API(cartTag).RECORD_PHONE,
    { phone },
    {
      headers: {
        Prefer: "code=200, example=default",
      },
    }
  );
};

export const verifyPhone = async (
  cartTag: string,
  pin: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API(cartTag).VERIFY_PHONE,
    { pin },
    {
      headers: {
        Prefer: "code=200, example=default",
      },
    }
  );
};

export const recordEmail = async (
  cartTag: string,
  email: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API(cartTag).RECORD_EMAIL,
    { email },
    {
      headers: {
        Prefer: "code=200",
      },
    }
  );
};

export const saveFacebookData = async (
  cartTag: string,
  facebookId: string,
  accessToken: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(M3_API(cartTag).SAVE_FACEBOOK_DATA, {
    facebookId,
    accessToken,
  });
};

export interface IdentifyLeadData {
  email?: string;
  phone_number: string;
}

export const identifyLead = async (
  payload: IdentifyLeadData
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.post(M3_API().IDENTIFY_LEAD, payload);
};
